import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()
export const readLeadList = async (path: string): Promise<Array<object>> => {
    try {
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/leads?path=${path}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            }
        });
        const data = await response.json();
        const urlResponse = await fetch(data.url, {
            method: 'GET',
          });

        const leadsArray = await urlResponse.json(); 

        return leadsArray;
    } catch (error) {
        console.error('Error fetching files:', error);
        // messageApi.open({
        //     type: 'error',
        //     content: `Erro ao buscar arquivos: ${error}`,
        // });
        return [];
    }
};